
const navigation = [
    {
        "key": "navigation.home",
        "string": "Home"
    },
    {
        "key": "navigation.webgis",
        "string": "Web GIS"
    },
    {
        "key": "navigation.glossary",
        "string": "Glossary"
    },
    {
        "key": "navigation.knowledge_platform",
        "string": "Knowledge platform"
    },
    {
        "key": "navigation.project_website",
        "string": "Project website"
    }
]

export default navigation



// WEBPACK FOOTER //
// ./src/i18n/en/landingpage/navigation.js